<template>
  <div class="achievements-list">
    <div
      class="achievement-item"
      :class="{ locked: locked, selected: isSelected(achievement) }"
      v-for="(achievement, index) in achievements"
      :key="'today-' + index"
      @click="selectAchievement(achievement)"
    >
      <div class="achievement-icon">
        <span
          v-html="Array.isArray(achievement.icon) ? achievement.icon[0] : achievement.icon"
        ></span>
      </div>
      <div class="achievement-details">
        <div class="achievement-title">{{ achievement.title }}</div>
        <div class="achievement-description">{{ achievement.description }}</div>
      </div>
      <div class="achievement-stars" v-if="locked">
        <svg class="star" viewBox="0 0 22 22" width="18" height="18">
          <path
            d="M12,1.5l2.61,6.727l6.89,0.53l-5.278,4.688l1.5,7.055L12,16.67L6.278,20.5l1.5-7.055L2.5,8.757l6.89-0.53L12,1.5z"
            fill="currentColor"
            :class="{ 'locked-star': locked }"
          /></svg
        >x{{ achievement.stars - 1 }} →
        <svg class="star" viewBox="0 0 22 22" width="18" height="18">
          <path
            d="M12,1.5l2.61,6.727l6.89,0.53l-5.278,4.688l1.5,7.055L12,16.67L6.278,20.5l1.5-7.055L2.5,8.757l6.89-0.53L12,1.5z"
            fill="currentColor"
            :class="{ 'locked-star': locked }"
          /></svg
        >x{{ achievement.stars }}
      </div>
      <div class="achievement-stars" v-if="!locked">
        <svg
          v-for="i in achievement.stars"
          :key="i"
          class="star"
          viewBox="0 0 22 22"
          width="18"
          height="18"
        >
          <path
            d="M12,1.5l2.61,6.727l6.89,0.53l-5.278,4.688l1.5,7.055L12,16.67L6.278,20.5l1.5-7.055L2.5,8.757l6.89-0.53L12,1.5z"
            fill="currentColor"
            :class="{ 'locked-star': locked }"
          />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'AchievementList',

    props: {
      locked: Boolean,
      achievements: Array,
      selectedAchievement: Object,
    },

    mounted() {
      console.log('Mounting list, achievements:', this.achievements);
    },

    methods: {
      selectAchievement(achievement) {
        this.$emit('achievement-selected', achievement);
      },
      isSelected(achievement) {
        return this.selectedAchievement && this.selectedAchievement.id === achievement.id;
      },
    },
  };
</script>

<style scoped>
  .achievements-list {
    padding: 10px;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .achievement-item {
    display: flex;
    align-items: center;
    padding: 12px 15px;
    background-color: #202937;
    border: 1px solid #374051;
    border-radius: 8px;
    cursor: pointer;
  }

  .achievement-icon {
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    margin-right: 15px;
  }

  .achievement-details {
    flex: 1;
    text-align: left;
  }

  .achievement-title {
    font-weight: 600;
    margin-bottom: 4px;
  }

  .achievement-description {
    font-size: 14px;
    color: #8d8f97;
  }

  .achievement-stars {
    margin-left: 10px;
    display: flex;
    align-items: center;
    color: #e7b009;
  }

  .achievement-item.locked .achievement-stars {
    color: #555;
  }

  .achievement-item.locked {
    opacity: 0.7;
  }

  .achievement-item.selected {
    border: 2px solid rgba(147, 147, 236, 1);
    box-shadow: 0 0 8px #adadeb66;
  }
</style>
